(() => {
  const customValue = 'discount-descending';
  const customParam = 'discount_sort';
  const customParamValue = 'highest';
  const customSelector = '[data-custom-discount-sort]';
  let isSorting = false;

  const setCustomUi = () => {
    const customRadio = document.querySelector(customSelector);
    if (!customRadio) return;

    document.querySelectorAll('input[name="sort_by"]').forEach((radio) => {
      radio.checked = false;
    });
    customRadio.checked = true;

    const selectedLabel = document.querySelector('.cc-sort-selected');
    if (selectedLabel) selectedLabel.textContent = 'Største rabat';
  };

  const fetchPageCards = async (page, sectionId, baseUrl) => {
    const url = new URL(baseUrl.toString());
    url.searchParams.set('page', String(page));
    url.searchParams.set('section_id', sectionId);

    const response = await fetch(url.toString(), {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });
    if (!response.ok) throw new Error('Section request failed');

    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fetchedGrid = doc.querySelector('[data-discount-sort-pages]');
    if (!fetchedGrid) throw new Error('Product grid missing');

    return Array.from(fetchedGrid.children)
      .filter((item) => item.classList.contains('product-block'))
      .map((item) => document.importNode(item, true));
  };

  const loadAllCards = async (pageCount, sectionId, baseUrl) => {
    const pages = Array.from({ length: pageCount }, (_, index) => index + 1);
    const cardsByPage = new Array(pageCount);
    let nextIndex = 0;

    const worker = async () => {
      while (nextIndex < pages.length) {
        const index = nextIndex++;
        cardsByPage[index] = await fetchPageCards(pages[index], sectionId, baseUrl);
      }
    };

    const workerCount = Math.min(3, pages.length);
    await Promise.all(Array.from({ length: workerCount }, worker));
    return cardsByPage.flat();
  };

  const sortByDiscount = async (updateHistory) => {
    if (isSorting) return;

    const section = document.querySelector('[data-section-type="collection-template"]');
    const results = section && section.querySelector('.cc-filters-results');
    const grid = results && results.querySelector('[data-discount-sort-pages]');
    if (!section || !results || !grid) return;

    isSorting = true;
    setCustomUi();
    results.classList.add('is-discount-sorting');
    results.setAttribute('aria-busy', 'true');

    try {
      const pageCount = Math.max(1, parseInt(grid.dataset.discountSortPages || '1', 10));
      const sectionId = section.dataset.sectionId;
      const baseUrl = new URL(window.location.href);
      baseUrl.searchParams.delete('sort_by');
      baseUrl.searchParams.delete(customParam);
      baseUrl.searchParams.delete('page');
      baseUrl.searchParams.delete('section_id');

      const cards = await loadAllCards(pageCount, sectionId, baseUrl);
      cards.forEach((card, index) => {
        card.dataset.discountSortIndex = String(index);
      });
      cards.sort((a, b) => {
        const discountDifference =
          Number(b.dataset.discountPercent || 0) - Number(a.dataset.discountPercent || 0);
        return discountDifference ||
          Number(a.dataset.discountSortIndex || 0) - Number(b.dataset.discountSortIndex || 0);
      });

      grid.replaceChildren(...cards);
      const pagination = results.querySelector('.pagination');
      if (pagination) pagination.remove();

      const sortDetails = document.querySelector('#filter-sort');
      if (sortDetails) sortDetails.removeAttribute('open');

      if (updateHistory) {
        const updatedUrl = new URL(window.location.href);
        updatedUrl.searchParams.delete('sort_by');
        updatedUrl.searchParams.set(customParam, customParamValue);
        updatedUrl.searchParams.delete('page');
        window.history.pushState({}, '', updatedUrl.toString());
      }
    } catch (error) {
      console.error(error);
    } finally {
      results.classList.remove('is-discount-sorting');
      results.removeAttribute('aria-busy');
      isSorting = false;
    }
  };

  const getCustomControl = (target) => {
    if (!(target instanceof Element)) return null;
    if (target.matches(customSelector)) return target;

    const label = target.closest('label');
    if (!label || !label.htmlFor) return null;
    const control = document.getElementById(label.htmlFor);
    return control && control.matches(customSelector) ? control : null;
  };

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (target instanceof Element) {
      const label = target.closest('label');
      const labelledControl = label && label.htmlFor ? document.getElementById(label.htmlFor) : null;
      const standardControl = target.matches('input[name="sort_by"]') ? target : labelledControl;
      if (standardControl && standardControl.matches('input[name="sort_by"]')) {
        const standardUrl = new URL(window.location.href);
        standardUrl.searchParams.delete(customParam);
        window.history.replaceState({}, '', standardUrl.toString());
        return;
      }
    }

    const control = getCustomControl(target);
    if (!control) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    setCustomUi();
    sortByDiscount(true);
  }, true);

  const initialize = () => {
    const params = new URLSearchParams(window.location.search);
    if (params.get(customParam) === customParamValue) {
      setCustomUi();
      sortByDiscount(false);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
